import { useEditorStore } from "../store/editorStore";

export function HeaderBar() {
  const worldRevision = useEditorStore((state) => state.worldRevision);
  const world = useEditorStore((state) => state.world);
  const selectedPosition = useEditorStore(
    (state) => state.selectedPosition
  );
  const textureStatus = useEditorStore((state) => state.textureStatus);
  const projectVersionId = useEditorStore(
    (state) => state.projectVersionId
  );
  const resetVersionedProject = useEditorStore(
    (state) => state.resetVersionedProject
  );
  const undo = useEditorStore((state) => state.undo);
  const redo = useEditorStore((state) => state.redo);
  const saveProjectJson = useEditorStore(
    (state) => state.saveProjectJson
  );

  void worldRevision;

  const textureLabel =
    textureStatus.status === "ready"
      ? "Models: Java " + (textureStatus.versionId ?? "official")
      : textureStatus.status === "error"
        ? "Models: fallback"
        : "Models: loading";

  return (
    <header className="studio-header">
      <div className="brand-cluster">
        <div className="brand-mark" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
        <div>
          <div className="brand-title">Voxel Studio</div>
          <div className="brand-subtitle">
            Minecraft World Designer
          </div>
        </div>
      </div>

      <div className="header-status">
        <span className="status-chip">
          {world.blocks.size.toLocaleString()} blocks
        </span>
        <span className="status-chip status-chip-version">
          Java {projectVersionId}
        </span>
        <span
          className="status-chip status-chip-muted"
          title={textureStatus.detail}
        >
          {textureLabel}
        </span>
        <span className="status-chip status-chip-muted">
          {selectedPosition
            ? `${selectedPosition.x}, ${selectedPosition.y}, ${selectedPosition.z}`
            : "No selection"}
        </span>
      </div>

      <div className="header-actions">
        <button
          className="header-button"
          type="button"
          onClick={undo}
          disabled={world.undoStack.length === 0}
        >
          Undo
        </button>
        <button
          className="header-button"
          type="button"
          onClick={redo}
          disabled={world.redoStack.length === 0}
        >
          Redo
        </button>
        <button
          className="header-button"
          type="button"
          onClick={() => {
            const hasBlocks = world.blocks.size > 0;
            if (
              hasBlocks &&
              !window.confirm(
                "Changing Minecraft version starts a new empty project. Continue?"
              )
            ) {
              return;
            }
            resetVersionedProject();
          }}
        >
          Change version
        </button>
        <button
          className="header-button header-button-accent"
          type="button"
          onClick={saveProjectJson}
        >
          Save JSON
        </button>
      </div>
    </header>
  );
}
